import React, { Component } from 'react';
import DataFetcher from '../utils/DataFetcher';
import DevicePage from '../components/DevicePage';

class DeviceOfAgent extends Component {
  render() {
    const pageProps = {
      fetchSites: (params, callback) => {
        DataFetcher.agentSites(callback)
      },
      fetchDevices: (params, callback) => {
        DataFetcher.agentDevices(params, {
          success: callback
        })
      },
      fetchStatistic: (params, callback) => {
        DataFetcher.deviceStatistic(params, {
          success: callback
        })
      },
      fetchDeviceTypes: (params, callback) => {
        DataFetcher.deviceTypes(params, {
          success: callback
        })
      },
      updateDevice: (params, callback, completed) => {
        DataFetcher.updateDevice(params, {
          success: callback,
          completed
        })
      },
      logoutDevice: (params, callback) => {
        DataFetcher.logoutDevice(params, {
          success: callback
        })
      },
      restartDevice: (params, callback) => {
        DataFetcher.restartDevice(params, {
          success: callback
        })
      },
      alertDevice: (params, callback, completed) => {
        DataFetcher.agentDeviceAlert(params, {
          success: callback,
          completed
        })
      },
      sendGift: (params, callback, completed) => {
        DataFetcher.createGift(params, {
          success: callback,
          completed
        })
      },
      deviceLogLink: (record) => {
        return `/device_log/${encodeURIComponent(record.deviceId)}`
      }
    }

    return <DevicePage {...pageProps}/>
  }
}

export default DeviceOfAgent;


// WEBPACK FOOTER //
// ./src/modules/DeviceOfAgent.js